// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1979f61e","703":"9ed246ba"}[chunkId] + ".chunk.js";
};